export const newCompanyStatus = [
    {user_status_code: "0" ,user_status_title : "Pending" },
    {user_status_code: "1" ,user_status_title : "Submitted" },
    {user_status_code: "3" ,user_status_title : "SA Reverted" },
    {user_status_code: "2" ,user_status_title : "Accepted" },
    {user_status_code: "5" ,user_status_title : "Admin Reverted" },
    {user_status_code: "4" ,user_status_title : "Rejected" },
    {user_status_code: "6" ,user_status_title : "Agreement Execution" },
    {user_status_code: "7" ,user_status_title : "Ongoing Project" },
    {user_status_code: "8" ,user_status_title : "Completed" },
    {user_status_code: "15" ,user_status_title : "Suggestion" },
    {user_status_code: "16" ,user_status_title : "Waiting" }
    // {user_status_code: "7" ,user_status_title : "Ongo" }
]